import { render } from "./AnexosProjetoTab.vue?vue&type=template&id=5bf61eab&scoped=true"
import script from "./AnexosProjetoTab.vue?vue&type=script&lang=js"
export * from "./AnexosProjetoTab.vue?vue&type=script&lang=js"

import "./AnexosProjetoTab.vue?vue&type=style&index=0&id=5bf61eab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf61eab"]])

export default __exports__